Ext.define('SA.view.sidebar.business.searcheditor.BusinessSearchEditor', {
    alias: 'widget.business-search-editor',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-business-editor',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',

            items: [
                {
                    xtype: 'close-button'
                }, {
                    xtype: 'component',
                    cls: 'sa-business-editor-heading',
                    html: '<div class="sa-business-editor-title">Advanced Business Search</div><div class="sa-business-editor-instructions">Add 1-4 conditions to your search</div>'
                }
            ]
        }, {
            xtype: 'business-conditions',
            margin: '0 29 0 45',

            listeners: {
                'refresh:conditions': function(conditionsCt) {
                    var editor = this.up('business-search-editor');

                    editor.down('#addBtn').setDisabled(conditionsCt.getQuery().length > 3);

                    editor.updateDoneButton();

                    Ext.EventManager.idleEvent.addListener(() => editor.center(), null, {single: true});
                }
            }
        }, {
            autoEl: {tag: 'button'},
            cls: 'sa-business-editor-add-condition-btn',
            height: 54,
            itemId: 'addBtn',
            text: 'Add condition',
            width: 153,
            xtype: 'sa-button',

            handler() {
                var row = this.up('business-search-editor').down('business-conditions').addRow();

                row.query('.sa-menu-button')[0].el.focus();
            }
        }, {
            xtype: 'simple-container',
            cls: 'sa-business-editor-footer',

            items: [
                {
                    xtype: 'sa-button',
                    autoEl: {tag: 'button'},
                    itemId: 'doneBtn',
                    text: 'Search',
                    ui: 'primary',
                    width: 118,

                    handler() {
                        this.up('[onDoneButtonClick]').onDoneButtonClick();
                    }
                }, {
                    xtype: 'sa-button',
                    autoEl: {tag: 'button'},
                    text: 'Cancel',
                    width: 118,

                    handler() {
                        this.up('business-search-editor').destroy();
                    }
                }
            ]
        }
    ],

    afterRender() {
        this.callParent();
        this.down('close-button').el.focus();
    },

    initComponent() {
        this.callParent();

        this.down('business-conditions').addRow();
    },

    onDoneButtonClick() {
        var conditionsCt = this.down('business-conditions'),
            booleanOperator = conditionsCt.getBooleanOperator(),
            conditions = conditionsCt.getQuery();

        this.setLoading('Saving…');

        SA.data.BusinessSearches.create({conditions, booleanOperator}).then(search => {
            Ext.callback(this.callback, this.scope, [search]);

            this.setLoading(false);

            this.destroy();
        });
    },

    syncFields(field) {
        var conditionCt = field.up('business-condition-row'),
            fieldCombo = conditionCt.down('#fieldCombo'),
            operatorCombo = conditionCt.down('#operatorCombo'),
            queryField = fieldCombo.getValue(),
            valueField = conditionCt.down('#valueField'),
            valueFieldInputEl = valueField.inputEl,
            value = valueField.getValue().trim(),
            maskRe = /./,
            maxLength = 96,
            operators;

        switch (queryField) {
            case 'name':
                operators = ['~', 'startswith'];
            break;

            case 'sic':
                operators = [/^\d{8}$/.test(value) ? '=' : 'startswith'];
            break;

            case 'naics':
                operators = [/^\d{6}$/.test(value) ? '=' : 'startswith'];
            break;

            default:
                operators = ['>', '<', '=', '>=', '<=', '<>'];
                maskRe = /\d/;
        }

        valueField.maskRe = maskRe;

        operators = [
            ['>', 'is greater than'],
            ['<', 'is less than'],
            ['=', 'is equal to'],
            ['>=', 'is greater than or equal to'],
            ['<=', 'is less than or equal to'],
            ['<>', 'is not equal to'],
            ['~', 'contains'],
            ['startswith', 'starts with']
        ].filter(item => operators.includes(item[0]));

        operatorCombo.setItems(operators);

        valueField.regex = {
            naics: /^\d{1,6}$/,
            name: /.+/,
            numberOfEmployees: /^\d{1,15}$/,
            salesVolume: /^\d{1,15}$/,
            sic: /^\d{1,8}$/
        }[queryField];

        valueField.listType = null;

        switch (queryField) {
            case 'naics':
                valueField.regexText = 'Invalid NAICS';
                valueField.listType = 'naics';
            break;

            case 'sic':
                valueField.regexText = 'Invalid SIC';
                valueField.listType = 'sic';
            break;

            case 'numberOfEmployees':
            case 'salesVolume':
                maxLength = 15;
                valueField.regexText = 'This value must be a number';
            break;
        }

        valueFieldInputEl.set({maxLength});

        if (valueField.getValue()) {
            valueField.validate();
        }

        this.updateDoneButton();
    },

    updateDoneButton() {
        var conditionsCt = this.down('business-conditions'), 
            valueFields = conditionsCt.query('#valueField'),
            doneBtn = this.down('#doneBtn'),
            valid = conditionsCt.getQuery().length > 0;

        valueFields.forEach(valueField => {
            if (!Ext.isEmpty(valueField.getErrors())) {
                valid = false;
            }
        });

        doneBtn.setDisabled(!valid);
    }
});
